import isEqualLodash from 'lodash/fp/isEqual';
import isEmptyLodash from 'lodash/isEmpty';

export const isEmpty = (value: any) => isEmptyLodash(value);

export const isEqual = (value1: any, value2: any) => isEqualLodash(value1, value2);
